import { Link } from "react-router-dom";
import { BaseURL } from "../../config/axios";

const Index = ({ data = [] }) => {

    return (
        <>
            <div className="container mt-3 px-2 mb-3">
                <div className="text-justify px-3 py-1 darkmode_grey h-full">
                    <div className="flex text-center flex-col gap-6">
                        <h3 className="title">مشهور ترین دسته بندی ها</h3>
                    </div>
                    <div className="grid lg:grid-cols-5 md:grid-cols-4 sm:grid-cols-3 grid-cols-2 gap-6 p-6">
                        {data.map((c, i) => {
                            if (i < 10) return (
                                <div className=" px-1 pb-2" key={c.id}>
                                    <div className="no-gutters mx-auto sm:px-4 w-full h-full border rounded bg-gray-900 border-gray-600 text-center px-0 darkmode_lightgreyborder">
                                        <div className="text-center px-0 h-full">
                                            <Link to={`/categories/${c.slug}`} className="flex flex-col h-full">
                                                <div className="centerOfParent overflow-hidden max-w-full max-h-96 rounded border border-gray-900 lazy-loaded grow">
                                                    <img className="w-full h-auto object-contain" placeholder='blur' blurDataURL='/images/placeholder-1.png'
                                                        width={100} height={100} src={BaseURL + c.painting_image?.path} alt={c.title} title={c.title} />
                                                </div>
                                                <div className="font-center py-2 text-gray-100">
                                                    {c.title}
                                                </div>
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            )
                        })}
                    </div>
                    <center><Link to="/categories" className="bg-gray-200 rounded-lg px-4 py-2  text-md">همه دسته‌بندی‌ها</Link></center>
                </div>
            </div>
        </>
    );
};

export default Index;